// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Markdown Renderer Styles */

/* Table Styling */
.markdown-renderer table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
  background-color: #ffffff;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: none;
}

.markdown-renderer thead {
  background-color: #f8fafc;
}

.markdown-renderer th {
  padding: 8px 12px;
  text-align: center;
  font-weight: 500;
  font-size: 0.8125rem;
  color: #64748b;
  border-bottom: 1px solid #e1e5e9;
  background-color: #f8fafc;
}

.markdown-renderer td {
  padding: 8px 12px;
  text-align: center;
  font-size: 0.8125rem;
  color: #475569;
  border-bottom: 1px solid #f1f5f9;
}

.markdown-renderer tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.markdown-renderer tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.markdown-renderer tbody tr:hover {
  background-color: #f1f5f9;
}

.markdown-renderer tbody tr:last-child td {
  border-bottom: none;
}

/* Heading Styles */
.markdown-renderer h2 {
  font-size: 1rem;
  font-weight: 600;
  color: #334155;
  margin: 16px 0 12px 0;
  line-height: 1.4;
}

.markdown-renderer h2:first-child {
  margin-top: 0;
}

/* Code Block Styles */
.markdown-renderer pre {
  background-color: #f8fafc;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  padding: 16px;
  overflow-x: auto;
  margin: 16px 0;
}

/* Override pre styles for SQL code blocks - multiple selectors for compatibility */
.markdown-renderer pre:has(.sql-code-block-wrapper),
.markdown-renderer pre .sql-code-block-wrapper,
.markdown-renderer pre[class*="sql"],
.markdown-renderer .sql-code-block-wrapper {
  border: 1px solid #e5e7eb !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.markdown-renderer code {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 0.875rem;
  background-color: #f8fafc;
  padding: 2px 6px;
  border-radius: 3px;
}

.markdown-renderer pre code {
  background-color: transparent;
  padding: 0;
}

/* Paragraph and Text Styles */
.markdown-renderer p {
  margin: 12px 0;
  line-height: 1.6;
  color: #475569;
  font-size: 0.875rem;
}

/* List Styles */
.markdown-renderer ul,
.markdown-renderer ol {
  margin: 12px 0;
  padding-left: 24px;
}

.markdown-renderer li {
  margin: 6px 0;
  line-height: 1.6;
  color: #475569;
  font-size: 0.875rem;
}

/* Strong/Bold Text */
.markdown-renderer strong {
  font-weight: 600;
  color: #1e293b;
}

/* Relationship Discovery Content - Preserve newlines */
.markdown-renderer .relationship-discovery {
  white-space: pre-wrap;
}

/* SQL Code Block - Remove all borders and margins */
.markdown-renderer pre:has(code[class*="language-sql"]) {
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

/* Ensure SQL code blocks have no borders or margins */
.markdown-renderer pre code[class*="language-sql"] {
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

/* SQL Code Block Wrapper - Enhanced styling with consistent design */
.sql-code-block-wrapper,
.markdown-renderer .sql-code-block-wrapper {
  border: 1px solid #e2e8f0 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: block !important;
  outline: none !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
  width: 100% !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  transition: box-shadow 0.2s ease !important;
}

.sql-code-block-wrapper:hover,
.markdown-renderer .sql-code-block-wrapper:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

/* Override any pre tag that might wrap SQL code blocks */
.markdown-renderer pre:has(.sql-code-block-wrapper) {
  border: 1px solid #e5e7eb !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

/* SQL Code Block Editor - Remove all borders and margins */
.sql-code-block-editor {
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.sql-code-block-editor .cm-editor,
.sql-code-block-editor .cm-wrapper,
.sql-code-block-editor .cm-scroller,
.sql-code-block-editor .cm-content,
.sql-code-block-editor .cm-gutters,
.sql-code-block-editor .cm-theme-light .cm-gutters {
  border: none !important;
  margin: 0 !important;
  border-radius: 0 !important;
}

.sql-code-block-editor .cm-gutters,
.sql-code-block-editor .cm-theme-light .cm-gutters {
  border-right: none !important;
  border-left: none !important;
  border-top: none !important;
  border-bottom: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/MarkdownRenderer/MarkdownRenderer.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mFAAmF;AACnF;;;;EAIE,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;;EAEE,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,oDAAoD;EACpD,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA,yDAAyD;AACzD;EACE,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;;;;;EAME,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;AAChC","sourcesContent":["/* Markdown Renderer Styles */\n\n/* Table Styling */\n.markdown-renderer table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 12px 0;\n  background-color: #ffffff;\n  border: 1px solid #e1e5e9;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.markdown-renderer thead {\n  background-color: #f8fafc;\n}\n\n.markdown-renderer th {\n  padding: 8px 12px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 0.8125rem;\n  color: #64748b;\n  border-bottom: 1px solid #e1e5e9;\n  background-color: #f8fafc;\n}\n\n.markdown-renderer td {\n  padding: 8px 12px;\n  text-align: center;\n  font-size: 0.8125rem;\n  color: #475569;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.markdown-renderer tbody tr:nth-child(even) {\n  background-color: #f8fafc;\n}\n\n.markdown-renderer tbody tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n.markdown-renderer tbody tr:hover {\n  background-color: #f1f5f9;\n}\n\n.markdown-renderer tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Heading Styles */\n.markdown-renderer h2 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #334155;\n  margin: 16px 0 12px 0;\n  line-height: 1.4;\n}\n\n.markdown-renderer h2:first-child {\n  margin-top: 0;\n}\n\n/* Code Block Styles */\n.markdown-renderer pre {\n  background-color: #f8fafc;\n  border: 1px solid #e1e5e9;\n  border-radius: 4px;\n  padding: 16px;\n  overflow-x: auto;\n  margin: 16px 0;\n}\n\n/* Override pre styles for SQL code blocks - multiple selectors for compatibility */\n.markdown-renderer pre:has(.sql-code-block-wrapper),\n.markdown-renderer pre .sql-code-block-wrapper,\n.markdown-renderer pre[class*=\"sql\"],\n.markdown-renderer .sql-code-block-wrapper {\n  border: 1px solid #e5e7eb !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.markdown-renderer code {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 0.875rem;\n  background-color: #f8fafc;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.markdown-renderer pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n/* Paragraph and Text Styles */\n.markdown-renderer p {\n  margin: 12px 0;\n  line-height: 1.6;\n  color: #475569;\n  font-size: 0.875rem;\n}\n\n/* List Styles */\n.markdown-renderer ul,\n.markdown-renderer ol {\n  margin: 12px 0;\n  padding-left: 24px;\n}\n\n.markdown-renderer li {\n  margin: 6px 0;\n  line-height: 1.6;\n  color: #475569;\n  font-size: 0.875rem;\n}\n\n/* Strong/Bold Text */\n.markdown-renderer strong {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Relationship Discovery Content - Preserve newlines */\n.markdown-renderer .relationship-discovery {\n  white-space: pre-wrap;\n}\n\n/* SQL Code Block - Remove all borders and margins */\n.markdown-renderer pre:has(code[class*=\"language-sql\"]) {\n  border: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n}\n\n/* Ensure SQL code blocks have no borders or margins */\n.markdown-renderer pre code[class*=\"language-sql\"] {\n  border: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n}\n\n/* SQL Code Block Wrapper - Enhanced styling with consistent design */\n.sql-code-block-wrapper,\n.markdown-renderer .sql-code-block-wrapper {\n  border: 1px solid #e2e8f0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: block !important;\n  outline: none !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;\n  width: 100% !important;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n  transition: box-shadow 0.2s ease !important;\n}\n\n.sql-code-block-wrapper:hover,\n.markdown-renderer .sql-code-block-wrapper:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;\n}\n\n/* Override any pre tag that might wrap SQL code blocks */\n.markdown-renderer pre:has(.sql-code-block-wrapper) {\n  border: 1px solid #e5e7eb !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n}\n\n/* SQL Code Block Editor - Remove all borders and margins */\n.sql-code-block-editor {\n  border: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.sql-code-block-editor .cm-editor,\n.sql-code-block-editor .cm-wrapper,\n.sql-code-block-editor .cm-scroller,\n.sql-code-block-editor .cm-content,\n.sql-code-block-editor .cm-gutters,\n.sql-code-block-editor .cm-theme-light .cm-gutters {\n  border: none !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n}\n\n.sql-code-block-editor .cm-gutters,\n.sql-code-block-editor .cm-theme-light .cm-gutters {\n  border-right: none !important;\n  border-left: none !important;\n  border-top: none !important;\n  border-bottom: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
